module.exports = __webpack_public_path__ + "img/logo.ddd7f813.png";